(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const hero = root.querySelector('.art-hero-art');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const gallery = root.querySelector('[data-gallery]');
    const cards = [...gallery.querySelectorAll('[data-object]')];
    root.querySelectorAll('[data-view]').forEach((button) => button.addEventListener('click', () => {
      if (gallery.dataset.layout === button.dataset.view) return;
      const before = cards.map(card => card.getBoundingClientRect());
      gallery.dataset.layout = button.dataset.view;
      root.querySelectorAll('[data-view]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      if (!reduced.matches) cards.forEach((card,index) => {
        const after = card.getBoundingClientRect();
        card.animate([{transform:`translate(${before[index].left-after.left}px,${before[index].top-after.top}px) scale(${before[index].width/after.width},${before[index].height/after.height})`,transformOrigin:'top left'},{transform:getComputedStyle(card).transform,transformOrigin:'top left'}],{duration:650,easing:'cubic-bezier(.22,1,.36,1)'});
      });
    }));
    const menu = root.querySelector('.art-menu');
    menu?.querySelectorAll('a').forEach(link => link.addEventListener('click',()=>{if(menu)menu.open=false;}));
    const objects = {
      fan:{title:'Korean folding fan',image:'fan.webp?v=1793097463',copy:'A traditional folding fan, imagined for everyday moments.'},
      shirt:{title:'A little more lemon',image:'shirt.webp?v=1793097520',copy:'LOGIN YOUR DAY, imagined as a lemon print T-shirt.'},
      ring:{title:'Floral signet ring',image:'ring.webp?v=1793097527',copy:'A floral signet, imagined as an everyday detail.'},
      tea:{title:'Tea, together',image:'tea.webp?v=1793097506',copy:'Liquid tea sticks and a clear straw tumbler, together.'},
      bottle:{title:'A clear companion',image:'bottle.webp?v=1793097513',copy:'A transparent straw tumbler for your daily ritual.'},
      mask:{title:'A moment for yourself',image:'mask.webp?v=1793097500',copy:'A sheet mask concept for a quiet moment of care.'}
    };
    const keys = cards.map(card=>card.dataset.object), dialog = root.querySelector('.art-dialog');
    let objectIndex = 0, origin = null;
    const show = key => {
      const item = objects[key]; objectIndex = keys.indexOf(key);
      root.querySelector('#art-dialog-title').textContent = item.title;
      const image = root.querySelector('[data-dialog-image]');
      image.src = 'https://cdn.shopify.com/s/files/1/0799/7924/9922/files/' + item.image;
      image.alt = 'Concept: ' + item.title;
      root.querySelector('[data-dialog-copy]').textContent = item.copy;
    };
    cards.forEach(card => card.addEventListener('click',()=>{
      origin = card; show(card.dataset.object); dialog.showModal();
      root.querySelector('[data-close]').focus();
    }));
    const close = () => dialog.close();
    root.querySelector('[data-close]').addEventListener('click',close);
    dialog.addEventListener('click',event=>{
      const r=dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();
    });
    dialog.addEventListener('close',()=>origin?.focus({preventScroll:true}));
    root.querySelector('[data-prev]').addEventListener('click',()=>show(keys[(objectIndex-1+keys.length)%keys.length]));
    root.querySelector('[data-next]').addEventListener('click',()=>show(keys[(objectIndex+1)%keys.length]));
    document.addEventListener('keydown',event=>{if(event.key==='Escape')if(menu)menu.open=false;});
    if (!reduced.matches) {
      const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        const photo=entry.target.matches('.art-object,.art-product-picture');
        entry.target.animate(photo?[{opacity:.7,translate:'0 28px'},{opacity:1,translate:'0 0'}]:[{opacity:.5,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:photo?1000:700,easing:'cubic-bezier(.22,1,.36,1)'});
        observer.unobserve(entry.target);
      }),{threshold:.12});
      root.querySelectorAll('[data-reveal]').forEach(element=>observer.observe(element));
      root.querySelectorAll('.art-hero h1 span').forEach((element,index)=>element.animate([{opacity:.25,transform:'translateY(32px)'},{opacity:1,transform:'translateY(0)'}],{duration:1100,delay:index*100,easing:'cubic-bezier(.22,1,.36,1)'}));
      hero?.animate([{opacity:.6,translate:'30px 0'},{opacity:1,translate:'0 0'}],{duration:1300,easing:'cubic-bezier(.22,1,.36,1)'});
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document.querySelector('#MainContent')),{once:true});
  else init(document.querySelector('#MainContent'));
  document.addEventListener('shopify:section:load',event=>init(document.querySelector('#MainContent')));
})();

(() => {
 function initPreview(){
  const product=document.querySelector('#lyd-product');
  if(!product||product.dataset.shopReady)return;
  product.dataset.shopReady='true';
  product.querySelectorAll('[data-photo]').forEach(button=>button.addEventListener('click',()=>{
   const image=product.querySelector('#shop-product-image');
   image.src=button.dataset.photo;image.alt=button.dataset.alt;
   product.querySelectorAll('[data-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
   product.querySelector('.shop-image-caption').textContent=button.textContent==='Still life'?'ALPHA / Lemon · Art composition':'ALPHA / Lemon · Original product photograph';
  }));
  document.querySelectorAll('.menu-drawer__navigation a[href*="#"]').forEach(link=>link.addEventListener('click',()=>{link.closest('.menu-drawer')?.querySelector('.menu-drawer__close-button')?.click();}));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPreview,{once:true});else initPreview();
 document.addEventListener('shopify:section:load',initPreview);
})();
